const mapNames = {
  logisticDelivery: 'logisticDelivery',
  powerBalancing: 'powerBalancing',
  vehicleState: 'vehicleState',
  default: 'default',
  coverage: 'coverage',
  vehicleStory: 'vehicleStory',
};

export default mapNames;
